import React, { useState, useContext, useRef } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";
import moment from "moment/moment";

const Company_invoice_item_ledger_modal = (props) => {
    return (
        <>
            {props.show ? (
                <>
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative  my-6 mx-auto w-11/12 sm:w-5/6 md:w-2/3 lg:w-5/6">
                    {/*content*/}
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    {/*header*/}
                    <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                        <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                            وەسڵ
                        </h3>
                        <button
                        className="p-1 ml-auto bg-transparent border-0 text-black opacity-80 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        onClick={() => props.setshow(false)}
                        >
                        <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                            X
                        </span>
                        </button>
                    </div>
                    {/*body*/}
                    <div className="relative p-4 sm:p-6 flex-auto max-h-[80vh] overflow-y-auto">
                        <div className="overflow-x-auto">
                        <table className="min-w-full leading-normal text-[10px] sm:text-xs md:text-sm">
                            <thead>
                                <tr>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                        ناوی کاڵا - کۆد
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                        نرخی کڕین
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                        بڕ - کۆ
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                        بڕی (CBI) م۳
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                        نرخ - تاک
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                        نرخ - کۆ
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                        کۆی نرخ
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                        کۆی نرخ (دراوی بنچینەیی)
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {props?.invoice_detail?.items?.map((lis, index) => (
                                <tr key={index}>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                    <div className="flex">
                                        <p className="text-gray-900 whitespace-no-wrap ml-1">
                                        {lis?.item_name}
                                        </p>
                                        <p className="text-gray-900 whitespace-no-wrap">
                                        -
                                        </p>
                                        <p className="text-gray-900 whitespace-no-wrap mr-1">
                                        {lis?.item_barcode}
                                        </p>
                                    </div>
                                    </td>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                        {numberbeautify(lis?.company_invoice_item_base_price)}
                                    </td>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                        {Number(lis?.company_invoice_item_qty)/Number(lis?.item_unit_one_of_many)}
                                    </td>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                        {numberbeautify(lis?.company_invoice_item_cbi_m3)}
                                    </td>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                        {numberbeautify(money_rounding(Number(lis?.company_invoice_item_price)/Number(lis.item_unit_one_of_many)))} $
                                    </td>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                        {numberbeautify(money_rounding(Number(lis?.company_invoice_item_price)))} $
                                    </td>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                        {numberbeautify(money_rounding(Number(lis?.company_invoice_item_price)*(Number(lis?.company_invoice_item_qty)/Number(lis?.item_unit_one_of_many))))} $
                                    </td>
                                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                        {numberbeautify(money_rounding(Number(lis?.company_invoice_item_base_price)*(Number(lis?.company_invoice_item_qty)/Number(lis?.item_unit_one_of_many))))}
                                    </td>
                                </tr>
                                ))}
                            </tbody>
                            </table>
                        </div>
                    </div>
                    {/*footer*/}
                    <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                        <button
                            className="bg-black text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                            type="button"
                            onClick={() => {
                                props.setshow(false);
                            }}
                        >
                            داخستن
                        </button>
                    </div>
                    </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
            ):null}
        </>
    )
}

export default Company_invoice_item_ledger_modal